import React from 'react';
const IconActionRename = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.59 8.49998L6.09 19H4V16.91L15.92 4.99998L19.41 8.49998L20.83 7.07998L15.92 2.16998L2 16.09V21H6.91L18 9.90998L16.59 8.49998Z" fill="#2D2E2E"/>
<path d="M21.4298 19.43C20.7798 19.89 20.3098 20.01 19.9998 20.01C19.5998 20.01 19.4598 19.89 19.0598 18.75C18.7098 17.75 18.2298 16.38 16.6398 16.06C14.1298 15.56 12.1298 17.65 9.00977 21H11.7498C13.5398 19.11 15.0098 17.77 16.2398 18.02C16.6698 18.11 16.8498 18.51 17.1698 19.41C17.5298 20.45 18.0798 22.01 19.9998 22.01C20.9098 22.01 21.8498 21.62 22.8598 20.85L21.4298 19.43Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionRename;